import type { ReactNode } from 'react'
import { useState } from 'react'

import { AiPassphraseRecoveryContext } from '@/src/domains/ai/contexts/AiPassphraseRecovery.context'
import { useAiSetup } from '@/src/domains/ai/hooks/useAiSetup'
import { isAiPassphraseRecoverable } from '@/src/domains/ai/utils/isAiPassphraseRecoverable'

export interface AiPassphraseRecoveryProviderProps {
  children: ReactNode
}

export const AiPassphraseRecoveryProvider = ({ children }: AiPassphraseRecoveryProviderProps) => {
  const { verification } = useAiSetup()
  const isRecoverable = isAiPassphraseRecoverable(verification)

  const [isRecovering, setIsRecovering] = useState(false)

  return (
    <AiPassphraseRecoveryContext.Provider value={{ isRecoverable, isRecovering, setIsRecovering }}>
      {children}
    </AiPassphraseRecoveryContext.Provider>
  )
}
